'use strict';

angular.module('clientDashboardApp').directive('truncatedColumn', ['$log', '$window', function ($log, $window) {
  return {
    restrict: 'A',
    scope: {
      text: '='
    },
    template: '<span class="nowrap truncated-column" style="text-transform: uppercase;" uib-tooltip="{{originalText}}" tooltip-enable="{{isTruncated}}">\
                  <span class="truncated-text-container"></span>\
                </span>',
    link: function (scope, elem, attrs, ctrl) {
      if(!angular.isDefined(scope.text)){
        return;
      }
      if(!angular.isDefined(parseInt(attrs.maxChars))){
        $log.warn('Invalid maxChars! maxChars:' + attrs.maxChars);
        return;
      }

      var w = angular.element($window);
      scope.originalText = scope.text;
      scope.displayText = "";

      $(elem).find('span.truncated-text-container').text(scope.originalText);
      var parentWidth = $(elem).width();
      scope.originalChildWidth = $(elem).find("span.truncated-text-container").width();

      $(elem).find('span.tooltip-container').css({width: scope.originalChildWidth + 17});

      scope.displayText = truncateIfNecessary(scope.originalText);
      $(elem).find('span.truncated-text-container').text(scope.displayText);

      parentWidth = $(elem).width();
      $(elem).find('span.full-width-tooltip').css({width: parentWidth});

      w.bind('resizeEnd', function() {
        scope.displayText = truncateIfNecessary(scope.originalText);
        $(elem).find('span.truncated-text-container').text(scope.displayText);
        parentWidth = $(elem).width();
        $(elem).find('span.full-width-tooltip').css({width: parentWidth});
      });

      function truncateIfNecessary(originalText){
        var result;
        if(!parentBufferAtLeast(10)){
          result = truncateToMaxChars(originalText);
        }
        else{
          scope.isTruncated = false;
          result = originalText;
        }

        return result;
      }

      function parentBufferAtLeast(buffer){
        return (parentWidth - scope.originalChildWidth) >= buffer;
      }

      function truncateToMaxChars(text){
        var maxChars = parseInt(attrs.maxChars);
        var truncatedText = text.substring(0,maxChars + 1);
        if(text.length > attrs.maxChars){
          scope.isTruncated = true;
          return truncatedText+"...";
        }
        else{
          scope.isTruncated = false;
          return truncatedText;
        }
      }
    }
  }
}]);
